import { render, staticRenderFns } from "./spec.vue?vue&type=template&id=646e1359&scoped=true"
import script from "./spec.vue?vue&type=script&lang=js"
export * from "./spec.vue?vue&type=script&lang=js"
import style0 from "./spec.vue?vue&type=style&index=0&id=646e1359&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646e1359",
  null
  
)

export default component.exports